var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnCarOption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1970_18143)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.1324,
    cy: 18.4372,
    rx: 10.021,
    ry: 9.68805,
    fill: "#006AF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6534 18.4372C27.6534 23.4958 23.4068 27.6252 18.1324 27.6252C12.858 27.6252 8.61133 23.4958 8.61133 18.4372C8.61133 13.3786 12.858 9.24915 18.1324 9.24915C23.4068 9.24915 27.6534 13.3786 27.6534 18.4372Z",
    stroke: "#006AF5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1970_18143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.237 18.7141C32.237 26.0658 26.0676 32.0542 18.4213 32.0542C10.7749 32.0542 4.60547 26.0658 4.60547 18.7141C4.60547 11.3624 10.7749 5.37402 18.4213 5.37402C26.0676 5.37402 32.237 11.3624 32.237 18.7141Z",
    stroke: "#006AF5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1970_18143",
    x: 4.11133,
    y: 4.74915,
    width: 28.042,
    height: 27.3761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1970_18143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1970_18143",
    x: 0.105469,
    y: 0.874023,
    width: 36.6318,
    height: 35.6802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1970_18143"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCarOption);
export default __webpack_public_path__ + "static/media/btn_car_option.a88b957e6ef5c62e07cd19e59fed1049.svg";
export { ForwardRef as ReactComponent };